// AnswerOption component - selectable answer card with title and optional subtitle
import * as styles from './AnswerOption.css';

export type AnswerOptionProps = {
  id: string;
  title: string;
  subtitle: string | null;
  isSelected: boolean;
  onClick: () => void;
};

export const AnswerOption = ({
  id,
  title,
  subtitle,
  isSelected,
  onClick,
}: AnswerOptionProps) => {
  const containerClassName = isSelected
    ? `${styles.container} ${styles.containerSelected}`
    : styles.container;

  return (
    <button
      type="button"
      className={containerClassName}
      onClick={onClick}
      data-testid={`answer-option-${id}`}
      aria-pressed={isSelected}
    >
      <p className={styles.title}>{title}</p>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
    </button>
  );
};
